const HttpType = {
    '400': 'BAD_REQUEST',
    '401': 'UNAUTHORIZED',
    '403': 'FORBIDDEN',
    '404': 'NOT_FOUND',
    '000': 'GENERIC',
};

export default HttpType;
